import * as React from 'react';

import loadGoogleMapsApi from '../loadGoogleMapsApi';

type TGoogleMapsApiState = 'LOADING'|'AVAILABLE'|'FAILED';
type TAllowedLibrary = 'places';

type TGoogleMapsApiRequest = {
	key: string;
	libraries?: TAllowedLibrary[];
}
export const useWithGoogleMaps = ({key, libraries = []}: TGoogleMapsApiRequest) => {
	const [googleMapsApiState, setGoogleMapsApiState] = React.useState<TGoogleMapsApiState>('LOADING');

	React.useEffect(() => {
		loadGoogleMapsApi({key, libraries})
			.then(() => setGoogleMapsApiState('AVAILABLE'))
			.catch(() => setGoogleMapsApiState('FAILED'));
	}, []);

	return {
		googleMapsApiState,
		isAvailable: googleMapsApiState === 'AVAILABLE',
		api: window.google
	};
}
